import { PAGINATION_QUERY_CONST, PB_QUERY_CONST } from '../constants';
function getPaginationIndex(query, name) {
  if (!query || !name) return 1;
  const paginationIndex = query[`${PB_QUERY_CONST}[${name}]${PAGINATION_QUERY_CONST}`];
  return Number(paginationIndex) || 1;
}
export default getPaginationIndex;
//# sourceMappingURL=get-pagination-index.js.map